module.exports = __webpack_public_path__ + "img/walnuts.ce9bef39.svg";